import { APP_URL } from '../../constants';
import { useLanguage } from '../../i18n/LanguageContext';

const POPULAR = [
    { code: 'JP', bg: 'linear-gradient(135deg,#1fa37a,#0c5a45)', title: 'eSIM Japan · 10 GB', sub: '7 days · instant QR', price: '12.90', back: '+0.19 back' },
    { code: 'GM', bg: 'linear-gradient(135deg,#3a2b8f,#1a1150)', title: 'Gaming gift card', sub: 'Global · delivered in seconds', price: '50.00', back: '+0.75 back' },
    { code: 'ST', bg: 'linear-gradient(135deg,#e0466e,#8a1f45)', title: 'Streaming 3 months', sub: 'Region: Asia', price: '27.00', back: '+0.41 back' },
    { code: 'TR', bg: 'linear-gradient(135deg,#f29b2b,#b2531a)', title: 'eSIM Türkiye · 20 GB', sub: '30 days · 5G', price: '16.00', back: '+0.24 back' },
];

function RedPacketsSection() {
    const { t } = useLanguage();

    return (
        <section className="home-sec" id="red-packets">
            <div className="wrap spot">
                <div className="panel spot-rp rv rv-l">
                    <div className="env" data-theme-key="lny" aria-hidden="true">
                        <div className="pattern" />
                        <div className="seal">福</div>
                        <div className="env-meta">
                            <b>Happy New Year</b>
                            <span className="mono">88.00</span>
                        </div>
                    </div>
                    <div className="spot-copy">
                        <span className="status s-live">{t.mostLoved}</span>
                        <h3>
                            {t.spotTitle}{' '}
                            <span className="grad-gold">{t.spotTitleAccent}</span>
                        </h3>
                        <p>{t.spotLead}</p>
                        <div className="hero-ctas">
                            <a className="btn btn-red btn-sm" href={APP_URL}>
                                {t.createRedPacket}
                            </a>
                            <a className="btn btn-ghost btn-sm" href={APP_URL}>
                                {t.seeHowItWorks}
                            </a>
                        </div>
                    </div>
                </div>
                {/* <div className="panel popular rv rv-r" style={{ '--rv-delay': '100ms' }}>
                    <div className="tile-top" style={{ marginBottom: '.3rem' }}>
                        <b>{t.popularWeek}</b>
                        <a href={APP_URL} className="fine" style={{ color: 'var(--mint)', textDecoration: 'none' }}>
                            {t.exploreAll}
                        </a>
                    </div>
                    {POPULAR.map((row) => (
                        <a className="pop-row" href={APP_URL} key={row.code}>
                            <span className="pi" style={{ background: row.bg }}>
                                {row.code}
                            </span>
                            <span>
                                <b>{row.title}</b>
                                <small>{row.sub}</small>
                            </span>
                            <span className="price">
                                <span className="mono">{row.price}</span>
                                <small>{row.back}</small>
                            </span>
                        </a>
                    ))}
                </div> */}
            </div>
        </section>
    );
}

export default RedPacketsSection;
